import type { QueryClient } from '@tanstack/react-query'

import { queryCompanyGet } from '@api/company/company.queries'
import { queryCoverageGet } from '@api/coverage/coverage.queries'
import { queryPolicyGet } from '@api/policy/policy.queries'

export const coverageSheetPreload = async (
  coverageUuid: string,
  queryClient: QueryClient,
) =>
  queryClient
    .ensureQueryData(queryCoverageGet(coverageUuid))
    .then((coverage) =>
      Promise.all([
        queryClient.ensureQueryData(
          queryCompanyGet(coverage.insuredCompanyUuid),
        ),
        queryClient.ensureQueryData(
          queryCompanyGet(coverage.debtorCompanyUuid),
        ),
        queryClient.ensureQueryData(queryPolicyGet(coverage.policyUuid)),
      ]),
    )
